import MyQuestionsPage from "./MyQuestionsPage";

export default MyQuestionsPage;